/**
 * Identidade visual do jogador — uma cor por slot, e só um lugar que decide.
 *
 * Antes isto vivia duplicado: `SLOT_TINTS` no `GameScene` e outro no
 * `LobbyScene`, com valores DIFERENTES para o slot 0 (0xffffff contra
 * 0xf2f2f2). Duas tabelas concorrentes é exatamente como a cor do lobby
 * deixa de ser a cor do jogo sem ninguém notar — o mesmo motivo pelo qual a
 * regra do Wang mora só em `terrain/river.ts`.
 *
 * A ordem segue o slot da sala: 0 é sempre o anfitrião.
 */

/** Cor de cada slot, na ordem em que a sala os numera. */
export const SLOT_COLORS = [
  0xffffff, // P1 — anfitrião
  0x5ad46a, // P2 — convidado 1
  0xffd23c, // P3 — convidado 2
  0x4fc3f7, // P4 — convidado 3
] as const

/** Mesma cor em CSS, para o que desenha texto em vez de tingir sprite. */
export const SLOT_CSS = ['#ffffff', '#5ad46a', '#ffd23c', '#4fc3f7'] as const

/** Rótulo curto do papel, para a tela de sala. */
export const SLOT_ROLE = ['ANFITRIÃO', 'CONVIDADO 1', 'CONVIDADO 2', 'CONVIDADO 3'] as const

/** Cor do slot; branco para índice fora da faixa, nunca `undefined`. */
export const slotColor = (slot: number): number => SLOT_COLORS[slot] ?? 0xffffff

/** Idem, em CSS. */
export const slotCss = (slot: number): string => SLOT_CSS[slot] ?? '#ffffff'
